import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
export const tableOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    labelPosition: "right",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: "640px",
    emptyText: "暂无数据",
    menu: false,
    column: [
      {
        label: "车牌号",
        prop: "carNum",
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      {
        label: "车主姓名",
        prop: "ownerName",
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
        formatter: function (row, value) {
          return value ? value : "暂无";
        },
      },
      {
        label: "停车类型",
        prop: "parkType",
        searchSlot: false,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: "center",
        formatter: function (row, value) {
          return value == 1 ? "普通车" : value == 2 ? "专有车" : "暂无";
        },
      },
      {
        label: "停车场",
        prop: "parkingLotName",
        search: true,
        multiple: true,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      {
        label: "车辆类型",
        prop: "carTypeStr",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: "center",
      },
      {
        label: "车辆编号",
        prop: "carCode",
        search: false,
        multiple: true,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
        hide: true,
      },
      {
        label: "所属部门",
        prop: "deptName",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
        formatter: function (row, value) {
          return value ? value : "暂无";
        },
      },
    ],
  };
};
